<template>
    <Layout>
        <MainPageLoader />
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';
    import MainPageLoader from '@components/MainPageLoader';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: 'Loading page...',
            meta: [
                {
                    name: 'description',
                    content: 'Loading page...',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
            MainPageLoader,
        },
    };
</script>
